<div fxLayout="row" class="fxGap-large mgtp-medium mgbt-medium">
  <div fxLayout="row" class="fxGap-small" *ngFor="let item of filterItems">
    <kendo-switch size="small" [(ngModel)]="item.value" [attr.aria-labelledby]="item.id" (valueChange)="filterItemChange(item)"></kendo-switch>
    <label class="switch-label" [id]="item.id" (click)="toggleItemFilter(item)">{{item.text}}</label>
  </div>
</div>
